// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"523":"bede34d8","878":"8221e207"}[chunkId] + ".chunk.js";
};